import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { pushVirtualPageView, registerConversionClickTracking } from "@/analytics/gtm";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import MeetJeremy from "@/pages/MeetJeremy";
import About from "@/pages/About";
import Insurance from "@/pages/Insurance";
import Faqs from "@/pages/Faqs";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    pushVirtualPageView(location);
  }, [location]);
  useEffect(() => registerConversionClickTracking(), []);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="flex min-h-screen flex-col bg-white">
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/meet-jeremy" element={<MeetJeremy />} />
            <Route path="/about" element={<About />} />
            <Route path="/insurance-new-patients" element={<Insurance />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
